import React from 'react';
import { Portal } from 'react-portal';
import Icon from '@lyearn-team/frontend-components/dist/Icon';
import styled from 'react-emotion';
import { withTheme } from 'emotion-theming';

const Wrapper = styled.div`
  ${({ theme: { color } }) => `
    position: fixed;
    bottom: 0px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 100;
    background: #fff;
    padding: 10px 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    color: ${color.black1};
    font-weight: 500;
    box-shadow: 0px -1px 11px -2px var(--color-black2);
  `}
`;

const IconWrapper = styled.div`
  ${({ theme: { color } }) => `
    background: ${color.green};
    border-radius: 50%;
    width: 20px;
    height: 20px;
    padding: 1px 3px;
    margin-right: 10px;
  `}
`;

@withTheme
class CourseCompleteSnackBar extends React.Component {
  UNSAFE_componentWillMount() {
    this.popupNode = document.createElement('div');
    this.popupNode.style = 'position: absolute; bottom: -100px; z-index:1000;';

    document.body.appendChild(this.popupNode);
  }

  componentWillUnmount() {
    this.popupNode.parentNode.removeChild(this.popupNode);
  }

  render() {
    const theme = this.props.theme;
    return (
      <Portal node={this.popupNode}>
        <Wrapper>
          <IconWrapper theme={theme}>
            <Icon type="check" style={{ fill: theme.color.white }} />
          </IconWrapper>
          Course completed
        </Wrapper>
      </Portal>
    );
  }
}

export default CourseCompleteSnackBar;
